/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CancelAllOpenOrdersOptions,
  CancelAllOpenOrdersResponses,
} from '../types/CancelAllOpenOrders'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Cancel all open orders, if user passes orderbook or account_id on query params it will cancel all orders on specific orderbook or account, admin can cancel user's orders on specific orderbook
 * {@link /v1/orders}
 */
export function cancelAllOpenOrders<ThrowOnError extends boolean = true>(
  options: Options<CancelAllOpenOrdersOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<CancelAllOpenOrdersResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'DELETE',
      url: '/v1/orders',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CancelAllOpenOrdersResponses, ThrowOnError>>,
  )
}
